import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-429">
        <HeroSection data-id="element-430" />
      </div>
      <div id="about" data-id="element-431">
        <AboutSection data-id="element-432" />
      </div>
      <div id="services" data-id="element-433">
        <ServicesDetailSection data-id="element-434" />
      </div>
      <div id="work" data-id="element-435">
        <ProjectGallerySection data-id="element-436" />
      </div>
      <div id="contact" data-id="element-437">
        <QuoteFormSection data-id="element-438" />
      </div>
      <FeaturedProjectsSection data-id="element-439" />
      <div id="testimonials" data-id="element-440">
        <TestimonialsSection data-id="element-441" />
      </div>
      <WhyChooseUsSection data-id="element-442" />
      <CallToActionSection data-id="element-443" />
      <Footer data-id="element-444" />
    </>;
}